import { NgClass } from '@angular/common'
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core'
import { TruncationTooltipComponent } from '../truncation-tooltip/truncation-tooltip.component'

@Component({
  selector: 'app-filter-dropdown-trigger',
  standalone: true,
  imports: [NgClass, TruncationTooltipComponent],
  templateUrl: './filter-dropdown-trigger.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterDropdownTriggerComponent {
  public readonly label = input.required<string>()
  /** Shown instead of `label` between the lg and xl breakpoints. */
  public readonly shortLabel = input<string | null>(null)
  public readonly ariaLabel = input.required<string>()
  public readonly isActive = input(false)
  public readonly isOpen = input(false)
  public readonly maxWidthClass = input('')
  public readonly selectedCount = input<number | null>(null)
  public readonly showCount = computed(() => (this.selectedCount() ?? 0) >= 2)

  public readonly labelClasses = computed(() => [
    'tw-whitespace-nowrap',
    'tw-font-inter',
    'tw-text-sm',
    '!tw-font-normal',
    this.isActive() ? 'tw-text-gray-900' : 'tw-text-gray-500'
  ])
}
